'use client';

import * as React from 'react';
export const CompositeRootContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CompositeRootContext.displayName = "CompositeRootContext";
export function useCompositeRootContext(optional = false) {
  const context = React.useContext(CompositeRootContext);
  if (context === undefined && !optional) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>.');
  }
  return context;
}